$.plugins.button = {
	__init: function (config) {
		this.apply('widget', { label: config.label, value: config.value }).addClass('button');
	},
};



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/spingames/panel/js/button.js
 **/